const serviceInstances = {};

function getService(serviceName) {
	return serviceInstances[serviceName];
}

function setService(serviceName, service) {
	serviceInstances[serviceName] = service;
}

export { serviceInstances, getService, setService };
